/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'Utilizamos cookies apenas para acompanhar as visitas ao nosso website; não armazenamos dados pessoais.',
    cookiesAccept: 'Aceitar cookies',
    cookiesDeny: 'Recusar cookies',
    tabFAQs: 'Perguntas frequentes',
    tabSupport: 'Apoio',
    tabHistory: 'História',
    tabReviews: 'Histórias',
    tabTraining: 'Formação',
    tabUserTraining: 'Formação para utilizadores',
    tabHcpTraining: 'Formação para profissionais de saúde',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Gravidez',
    tabAbout: 'Sobre',
    tabNews: 'Notícias',
    tabCareers: 'Carreiras',
    tabOrders: '',
    tabNotifications: 'Notificações',
};
